export default __webpack_public_path__ + "static/media/willie.1b4790a6.jpeg";